var moduleMap = {
	"./close-icon": () => {
		return __webpack_require__.e(186).then(() => (() => ((__webpack_require__(6186)))));
	},
	"./environment-banner": () => {
		return __webpack_require__.e(643).then(() => (() => ((__webpack_require__(8024)))));
	},
	"./tooltip": () => {
		return __webpack_require__.e(17).then(() => (() => ((__webpack_require__(7017)))));
	},
	"./menu": () => {
		return __webpack_require__.e(916).then(() => (() => ((__webpack_require__(6916)))));
	},
	"./global-header": () => {
		return __webpack_require__.e(68).then(() => (() => ((__webpack_require__(9068)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});